<template>
    <footer class="app-footer" role="contentinfo">
        <div class="app-footer-line" aria-hidden="true" />
        <div  style='text-align: center;' v-if="this.$i18n.locale === 'zh-CN'">
          <span v-html="$t('footer.copyright1')"></span>
          <span @click="goToBeian" v-html="$t('footer.copyright2')"></span>
          
          </div>
        <p v-else style='text-align: center;'    v-html="$t('footer.copyright')">
        </p>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    methods: {
        goToBeian() {
        
            window.open('https://beian.miit.gov.cn/', '_blank');
        
        }
    }
}
</script>
<style scoped>
.app-footer {
 
}
.app-footer {
  
       z-index: 9999;
       background: #2b2b2d;
  flex-shrink: 0;
  width: 100%;
  background: #2b2b2d;
  padding: 36px 24px 40px;
  box-sizing: border-box;
}

.app-footer-line {
  max-width: min(960px, 86%);
  height: 2px;
  margin: 0 auto 20px;
  background: rgba(255, 255, 255, 0.22);
}

.app-footer-copy {
  cursor:pointer;
  margin: 0;
  text-align: center;
  font-size: 13px;
  line-height: 1.6;
  color: #b0b0b0;
  letter-spacing: 0.02em;
}
</style>